import request from "../utils/request";

// agentBillInvoice/list
export function agentBillInvoiceList(data) {
  return request({
    url: '/agentBillInvoice/list',
    method: 'get',
    params: data
  })
}

// agent/getTaxInfo
export function getTaxInfo(data) {
  return request({
    url: '/agent/getTaxInfo',
    method: 'get',
    params: data
  })
}

// agent/appealSettlement
export function appealSettlement(data) {
  return request({
    url: '/agent/appealSettlement',
    method: 'post',
    data: data
  })
}

// agent/getSettlementInvoice
export function getSettlementInvoice(data) {
  return request({
    url: '/agent/getSettlementInvoice',
    method: 'get',
    params: data
  })
}

// agentBillInvoice/dayInvoiceList
export function dayInvoiceList(data) {
  return request({
    url: '/agentBillInvoice/dayInvoiceList',
    method: 'get',
    params: data
  })
}

// agentBillInvoice/getInvoice
export function getInvoice(data) {
  return request({
    url: '/agentBillInvoice/getInvoice',
    method: 'get',
    params: data
  })
}
